(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cordus-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
  document.querySelectorAll('.cordus-landing').forEach(function(root){
  if(root.dataset.clInit)return; root.dataset.clInit='1';

  /* ---- "Agregar" lo maneja el <product-form-component> NATIVO de Atelier
     (AJAX rápido + abre el cart drawer vía CartAddEvent). No lo interceptamos.
     Aquí solo manejamos "Comprar ahora": añade y va directo a /checkout (1 clic). ---- */
  root.addEventListener('submit',function(e){
    var form=e.target.closest('form[data-cordus-buynow]'); if(!form)return;
    e.preventDefault();
    var btn=form.querySelector('button'); var lbl=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='Un momento…';}
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){return r.ok?r.json():Promise.reject(r);})
      .then(function(){window.location.href='/checkout';})
      .catch(function(){form.submit();});
  });

  /* ---- Wine finder ---- */
  var MAP={
    'ligero|cena':'cordus-100-chardonnay','ligero|regalo':'cordus-100-chardonnay','ligero|reunion':'cordus-rosado','ligero|tranquilo':'cordus-rosado',
    'versatil|cena':'cordus-ensamble-esencial','versatil|regalo':'cordus-ensamble-seleccion','versatil|reunion':'cordus-ensamble-esencial','versatil|tranquilo':'cordus-ensamble-seleccion',
    'intenso|cena':'cordus-100-nebbiolo','intenso|regalo':'cordus-100-nebbiolo','intenso|reunion':'cordus-ensamble-seleccion','intenso|tranquilo':'cordus-100-nebbiolo',
    'especial|cena':'cordus-oculto','especial|regalo':'avenencia','especial|reunion':'cordus-oculto','especial|tranquilo':'cordus-oculto'
  };
  var dataEl=root.querySelector('[data-cordus-finder-data]');
  var PROD={}; try{PROD=JSON.parse(dataEl.textContent);}catch(e){}
  var sel={intent:null,moment:null};
  root.querySelectorAll('.cl-chips').forEach(function(group){
    group.addEventListener('click',function(e){
      var b=e.target.closest('.cl-chip'); if(!b)return;
      group.querySelectorAll('.cl-chip').forEach(function(c){c.setAttribute('aria-pressed','false');});
      b.setAttribute('aria-pressed','true'); sel[group.dataset.group]=b.dataset.v; render();
    });
  });
  function render(){
    if(!sel.intent||!sel.moment)return;
    var h=MAP[sel.intent+'|'+sel.moment]; var p=PROD[h]; if(!p)return;
    var out=root.querySelector('[data-out]'), r=root.querySelector('[data-result]');
    var atc = p.available
      ? '<form class="cl-atc" action="/cart/add" method="post"><input type="hidden" name="id" value="'+p.vid+'"><button type="submit" class="cl-btn cl-btn--wine">Agregar</button></form>'
      : '<span class="cl-card__spec">Agotado</span>';
    r.innerHTML='<article class="cl-card"><a class="cl-card__media" href="'+p.url+'"><img src="'+(p.img||'')+'" alt="'+p.t+'" loading="lazy"></a>'+
      '<div class="cl-card__body"><h3 class="cl-card__title">'+p.t+'</h3>'+
      '<div class="cl-card__row"><span class="cl-price">'+p.price+' <span class="cl-price__cur">MXN</span></span>'+atc+'</div></div></article>';
    out.classList.add('is-on');
  }
  });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
